requirejs.config({
  'baseUrl': '/',
  'paths': {
    'app': 'skin/frontend/v3/default/js',
    // define lib paths
    'async': 'skin/frontend/v3/default/js/lib/requirejs/async',
    'jquery': 'skin/frontend/v3/default/js/lib/jquery/jquery-1.11.1.min',
    'jquery.isOnScreen': 'skin/frontend/v3/default/js/lib/jquery/jquery.isonscreen',
    'i18n': 'skin/frontend/v3/default/js/lib/i18next-1.7.7',
    'jquery.bjqs': 'skin/frontend/v3/default/js/lib/bjqs-1.3.min',
    'jquery.bxslider': 'skin/frontend/v3/default/js/lib/bxslider.min',
    'jquery.sumoselect': 'skin/frontend/v3/default/js/lib/jquery.sumoselect',
    'jquery.selectric': 'skin/frontend/v3/default/js/lib/jquery.selectric',
    'parsley': 'skin/frontend/v3/default/js/lib/jquery/parsley.min',
    'jquery.noUiSlider': 'skin/frontend/v3/default/js/lib/jquery/jquery.nouislider.all.min',
    'jquery.formatCurrency': 'skin/frontend/v3/default/js/lib/jquery/jquery.formatCurrency-1.4.0',
    'jquery.easing': 'skin/frontend/v3/default/js/lib/jquery/jquery.easing-1.3.pack',
    'jquery.mobileJustTouch': 'skin/frontend/v3/default/js/lib/jquery/jquery.mobile.just-touch',
    'jquery.sticky-sidebar':'skin/frontend/v3/default/js/lib/jquery/jquery.sticky-sidebar',
    'smartbanner': 'skin/frontend/v3/default/js/lib/smartbanner',
    'json2': 'skin/frontend/v3/default/js/lib/json2/json2',
    'jquery.cookie': 'skin/frontend/v3/default/js/lib/jquery/jquery.cookie',
    'jquery.autocomplete': 'skin/frontend/v3/default/js/lib/jquery/jquery.autocomplete.min',
    'underscore': 'skin/frontend/v3/default/js/lib/underscore/underscore',
    'backbone': 'skin/frontend/v3/default/js/lib/backbone/backbone',
    'backbone-validation': 'skin/frontend/v3/default/js/lib/backbone/backbone-validation-amd',
    'main': 'skin/frontend/v3/default/js/main',
    'photo-swipe': 'skin/frontend/v3/default/js/lib/photo-swipe/photoswipe.min',
    'photo-swipe-ui-default': 'skin/frontend/v3/default/js/lib/photo-swipe/photoswipe-ui-default.min',
    'flip-clock': 'skin/frontend/v3/default/js/lib/flipclock',
//    'tweenlite': 'skin/frontend/v3/default/js/lib/mightyslider/tweenlite'
    'mighty-slider': 'skin/frontend/v3/default/js/lib/mightyslider/mightyslider',
    'owl-carousel': 'skin/frontend/v3/default/js/lib/owl.carousel.min',
    'leaflet': 'skin/frontend/v3/default/js/lib/leaflet'},
  // shim declaration
  'shim': {
    'i18n': ['jquery'],
    'jquery.isOnScreen': ['jquery'],
    'jquery.easing': ['jquery'],
    'jquery.mobileJustTouch': ['jquery'],
    //'mighty-slider': ['jquery'],
    //'tweenlite': ['jquery'],
    'jquery.bjqs': ['jquery'],
    'jquery.bxslider': ['jquery'],
    'jquery.sumoselect': ['jquery'],
    'jquery.selectric': ['jquery'],
    'jquery.noUiSlider': ['jquery'],
    'jquery.formatCurrency': ['jquery'],
    'jquery.cookie': ['jquery'],
    'owl-carousel': ['jquery'],
    'jquery.autocomplete': ['jquery'],
    //'mighty-slider': ['tweenlite'],
    'main': [
      'jquery.autocomplete',
      'jquery.isOnScreen',
      'jquery.easing',
      'jquery.mobileJustTouch',
      'jquery.bjqs',
      'jquery.noUiSlider',
      'jquery.formatCurrency',
      'jquery.cookie',
      'jquery.bxslider',
      'smartbanner',
      'owl-carousel',
      'jquery.autocomplete',
      'leaflet'
    ]
  },
  // 'urlArgs': "bust=" + (new Date()).getTime(), //development
  'waitSeconds': 0
});

require(['app/takhfifan']);

define("app/config", function(){});

